module.exports = __webpack_public_path__ + "assets/helen-logo.04cf3a7917571dd46d711c96e16a5ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/helen-logo.png
// module id = 87
// module chunks = 0